<div class="row">
  <div class="col-md-6" style="margin: 10px 0">
    <div class="panel-default">
      <div class="geothermal-panel widget-head">
        <h3>Thermo-Collapse Model Results</h3>
      </div>
    </div>
    <div *ngIf="!hasThermalCollapseInputErrors() && thermalCollapseResponses && thermalCollapseResponses.length">
      <canvas
        id="graph-thermo-collapse"
        style="width: 100%; height: 350px"
      ></canvas>
    </div>
    <div *ngIf="hasThermalCollapseInputErrors()" class="error-container">
      <h5 class="text-danger"><b>Input Errors</b></h5>
      <ul class="error-list">
        <li
          *ngFor="let error of getThermalCollapseInputErrors()"
          class="text-danger"
        >
          Error {{ error.errorCode }}: {{ error.errorMessage }}
        </li>
      </ul>
    </div>
  </div>
  <div class="col-md-6" style="margin: 10px 0">
    <div class="panel-default">
      <div class="geothermal-panel widget-head">
        <h3>Unsupported Buckling Model Results</h3>
      </div>
    </div>
    <div
      [style.display]="
        !hasUnsupportedLengthInputErrors() &&
        !hasSolutionErrors() &&
        unsupportedLengthResponses &&
        unsupportedLengthResponses.outputs
          ? 'block'
          : 'none'
      "
    >
      <canvas
        id="graph-unsupported-buckling"
        style="width: 100%; height: 350px"
      ></canvas>
    </div>
    <div *ngIf="hasUnsupportedLengthInputErrors() || hasSolutionErrors()" class="error-container">
      <ng-container *ngIf="hasUnsupportedLengthInputErrors()">
        <h5 class="text-danger"><b>Input Errors</b></h5>
        <ul class="error-list">
          <li
            *ngFor="let error of getUnsupportedLengthInputErrors()"
            class="text-danger"
          >
            Error {{ error.errorCode }}: {{ error.errorMessage }}
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="hasSolutionErrors()">
        <h5 class="text-danger"><b>Solution Errors</b></h5>
        <ul class="error-list">
          <li *ngFor="let err of getSolutionErrors()" class="text-danger">
            {{ err.key }}: {{ err.message }}
          </li>
        </ul>
      </ng-container>
    </div>
  </div>
  <div
    class="col-md-12"
    style="margin: 10px 0"
    *ngIf="!hasThermalCollapseInputErrors()"
  >
    <h4
      class="collapsible-title"
      (click)="showThermalCollapse = !showThermalCollapse"
    >
      Thermo-Collapse Model Results
      <span
        class="collapsible-icon"
        [ngClass]="
          showThermalCollapse ? 's7-angle-down-circle' : 's7-angle-right-circle'
        "
      >
      </span>
    </h4>
  </div>
  <div class="col-md-12" *ngIf="!hasThermalCollapseInputErrors()">
    <div *ngIf="showThermalCollapse && thermalCollapseResponses && thermalCollapseResponses.length">
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th colspan="2">
              <strong>T1-{{ thermalCollapseResponses[0]?.temperature }}</strong>
            </th>
            <th colspan="2">
              <strong>T2-{{ thermalCollapseResponses[1]?.temperature }}</strong>
            </th>
            <th colspan="2">
              <strong>T3-{{ thermalCollapseResponses[2]?.temperature }}</strong>
            </th>
            <th colspan="2">
              <strong>T4-{{ thermalCollapseResponses[3]?.temperature }}</strong>
            </th>
            <th colspan="2">
              <strong>T5-{{ thermalCollapseResponses[4]?.temperature }}</strong>
            </th>
          </tr>
          <tr>
            <ng-container *ngFor="let t of [1, 2, 3, 4, 5]">
              <th><strong>Axial Stress</strong></th>
              <th><strong>API Collapse</strong></th>
            </ng-container>
          </tr>
          <tr>
            <ng-container *ngFor="let t of [1, 2, 3, 4, 5]">
              <th style="font-weight: normal; font-size: 90%">
                <strong>[{{ unitAxialStress }}]</strong>
              </th>
              <th style="font-weight: normal; font-size: 90%">
                <strong>[{{ unitApiCollapse }}]</strong>
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody></tbody>
        <tbody>
          <tr *ngFor="let i of getThermalCollapseRowIndexes()">
            <ng-container *ngFor="let t of [0, 1, 2, 3, 4]">
              <td>
                {{
                  thermalCollapseResponses[t]?.axialForce &&
                  thermalCollapseResponses[t].axialForce[i] !== undefined
                    ? (thermalCollapseResponses[t].axialForce[i] | toFixed : 3)
                    : "-"
                }}
              </td>
              <td>
                {{
                  thermalCollapseResponses[t]?.collapseRating &&
                  thermalCollapseResponses[t].collapseRating[i] !== undefined
                    ? (thermalCollapseResponses[t].collapseRating[i]
                      | toFixed : 3)
                    : "-"
                }}
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      *ngIf="
        showThermalCollapse &&
        (!thermalCollapseResponses || !thermalCollapseResponses.length)
      "
    >
      <em>No data available.</em>
    </div>
  </div>
  <div
    class="col-md-12"
    style="margin: 10px 0"
    *ngIf="!hasUnsupportedLengthInputErrors() && !hasSolutionErrors()"
  >
    <h4
      class="collapsible-title"
      (click)="showUnsupportedBuckling = !showUnsupportedBuckling"
    >
      Unsupported Buckling Model Results
      <span
        class="collapsible-icon"
        [ngClass]="
          showUnsupportedBuckling
            ? 's7-angle-down-circle'
            : 's7-angle-right-circle'
        "
      >
      </span>
    </h4>
  </div>
  <div class="col-md-12" *ngIf="!hasUnsupportedLengthInputErrors() && !hasSolutionErrors()">
    <div
      [style.display]="
        showUnsupportedBuckling &&
        unsupportedLengthResponses &&
        unsupportedLengthResponses.outputs
          ? 'block'
          : 'none'
      "
    >
      <div
        *ngIf="unsupportedLengthResponses && unsupportedLengthResponses.outputs"
      >
        <table class="table table-bordered table-sm">
          <thead>
            <tr>
              <th
                style="
                  border-top: 1px solid #fff;
                  border-left: 1px solid #fff;
                  border-bottom: 1px solid #fff;
                "
              ></th>
              <th><strong>Unsupported Length</strong></th>
              <th><strong>Max. Tot. Stress</strong></th>
              <th><strong>Max. ΔT</strong></th>
              <th><strong>Holliday</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style="border-top: 1px solid #fff; border-left: 1px solid #fff"
              ></td>
              <td style="font-weight: normal; font-size: 90%">
                <strong>[{{ unitUnsupportedLength }}]</strong>
              </td>
              <td style="font-weight: normal; font-size: 90%">
                <strong>[{{ unitMaxCompStress }}]</strong>
              </td>
              <td style="font-weight: normal; font-size: 90%">
                <strong>[{{ unitMaxDeltaT }}]</strong>
              </td>
              <td style="font-weight: normal; font-size: 90%">
                <strong>[{{ unitHolliday }}]</strong>
              </td>
            </tr>
          </tbody>

          <tbody>
            <tr *ngIf="unsupportedLengthResponses.outputs?.length >= 8">
              <td class="inelast-buck-cell" rowspan="8">Inelast. Buck</td>
                            <td>
                {{
                  unsupportedLengthResponses.outputs[0]?.unsupportedBuckling
                    | toFixed : 3
                }}
              </td>
              <td>
                {{
                  unsupportedLengthResponses.outputs[0]?.maxCompressiveStress
                    | toFixed : 3
                }}
              </td>
              <td>
                {{
                  unsupportedLengthResponses.outputs[0]?.maxDeltaT | toFixed : 1
                }}
              </td>
              <td>
                {{
                  unsupportedLengthResponses.outputs[0]?.hollidayFactor
                    | toFixed : 2
                }}
              </td>
            </tr>
            <ng-container
              *ngFor="
                let out of unsupportedLengthResponses.outputs;
                let i = index
              "
            >
              <tr *ngIf="i > 0 && i < 8">
                <td>{{ out.unsupportedBuckling | toFixed : 3 }}</td>
                <td>{{ out.maxCompressiveStress | toFixed : 3 }}</td>
                <td>{{ out.maxDeltaT | toFixed : 1 }}</td>
                <td>{{ out.hollidayFactor | toFixed : 2 }}</td>
              </tr>
            </ng-container>
            <tr *ngIf="unsupportedLengthResponses.outputs?.length >= 12">
              <td class="elast-buck-cell" rowspan="4">Elast. Buck</td>
              <td>
                {{
                  unsupportedLengthResponses.outputs[8]?.unsupportedBuckling
                    | toFixed : 3
                }}
              </td>              <td>
                {{
                  unsupportedLengthResponses.outputs[8]?.maxCompressiveStress
                    | toFixed : 3
                }}
              </td>
              <td>
                {{
                  unsupportedLengthResponses.outputs[8]?.maxDeltaT | toFixed : 1
                }}
              </td>
              <td>
                {{
                  unsupportedLengthResponses.outputs[8]?.hollidayFactor
                    | toFixed : 2
                }}
              </td>
            </tr>
            <ng-container
              *ngFor="
                let out of unsupportedLengthResponses.outputs;
                let i = index
              "
            >
              <tr *ngIf="i > 8 && i < 12">
                <td>{{ out.unsupportedBuckling | toFixed : 1 }}</td>
                <td>{{ out.maxCompressiveStress | toFixed : 1 }}</td>
                <td>{{ out.maxDeltaT | toFixed : 1 }}</td>
                <td>{{ out.hollidayFactor | toFixed : 2 }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <div
          *ngIf="
            !unsupportedLengthResponses || !unsupportedLengthResponses.outputs
          "
        >
          <em>No data available.</em>
        </div>
      </div>
    </div>
  </div>
</div>
